module.exports = __webpack_public_path__ + "fonts/f5ed160bfdaa3dab270bb4be13fbed75.woff";